module.exports = __webpack_public_path__ + "img/selected2-min.125830f3.png";